import React from 'react';
import { Navigate } from 'react-router-dom';

interface IAuthenticatedRouteProps {
  loggedIn: boolean;
  authResolved: boolean;
  children: React.ReactNode;
}

export const AuthenticatedRoute: React.FC<IAuthenticatedRouteProps> = ({
  loggedIn,
  authResolved,
  children,
}) => {
  if (!authResolved) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
